<h2 class="text-center"> Guardian List</h2>
<div class="table-responsive" *ngIf="!loading">
  <table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
    <thead>
    <tr>
    <th>Date Created</th>
    <th>Names</th>
    <th>Email</th>
    <th>Student Count</th>
    <th>Agent Enrollments</th>
    <th>Coupon</th>
    <th>Manage Students</th>
    <th>Manage Groupings</th>
    <th>Mobile Device</th>
    <th>Progress Email Show</th>
    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let guardian of guardians;">
        <td>{{guardian.datecreated}}</td>
        <td>{{guardian.names}}</td>
        <td>{{guardian.email}}</td>
        <td class="text-center">{{guardian.studentCount}}</td>
        <td>
            <a *ngIf="guardian.isAgent==1"
                [routerLink]="['/admin/couponEnrolment/agent',guardian.userId]"> {{guardian.agentEnrolmentCount}}</a>
            <a *ngIf="guardian.isAgent!=1"
                [routerLink]="['/admin/agent/createnewagent',guardian.userId]"> Make Agent</a>
        </td>
        <td class="text-center">
            <a *ngIf="guardian.coupon==0"
            [routerLink]="['/admin/couponEnrolment/agent',guardian.userId]"> NIL</a>
            <a *ngIf="guardian.coupon!=0"
            [routerLink]="['/admin/couponEnrolment/agent',guardian.userId]"> {{guardian.coupon}}</a>
        </td>

        <td class="text-center">
            <a *ngIf="guardian.server_guardian_id!=0"
            [routerLink]="['/admin/student/add',guardian.server_guardian_id]"><i class="fa fa-cog"></i></a>

        </td>
        <td class="text-center">
          <a  [routerLink]="['/batch/groupings/index/',guardian.server_guardian_id]"> {{guardian.groupingsCount}}</a>
        </td>
        <td class='text-center'>
            <a *ngIf="guardian.userId!=0"
            [routerLink]="['/admin/device/sync',guardian.userId]"><i class="fa fa-eye"></i></a>

        </td>
        <td></td>

    </tr>
    </tbody>

</table>
</div>
<app-empty [isEmpty]="isEmpty"></app-empty>
<app-loading [loading]="loading"></app-loading>

